module.exports = __webpack_public_path__ + "img/bc-step-1.df37f1ee.png";